import { Wrap } from '../../components/wap'
import { STATIC_OBS_URL } from '../../consts'

const bannerUrl = `${STATIC_OBS_URL}/website/home/news/banner.png?2`
export interface NewsListProps1 {
  data: {
    _id: string
    title: string
    thumbnail: string
    description: string
    url: string
    publishTime: string
    type: number
  }[]
  page: {
    total: number
    pageSize: number
    pageIndex: number
  }
}

const pagination = (params: NewsListProps1['page']) => {
  const result: { type: 'num' | 'cur' | 'pre' | 'next' | 'first' | 'last'; value: number }[] = []
  const leftFloat = 4
  const rightFloat = 4
  const { pageSize, pageIndex, total } = params
  const totalPage = Math.ceil(total / pageSize)
  for (let i = pageIndex - leftFloat; i <= pageIndex + rightFloat; i++) {
    if (i >= 1 && i <= totalPage) {
      const type = i === pageIndex ? 'cur' : 'num'
      result.push({ type, value: i })
    }
  }
  return result
}
export const NewsList1 = (props: NewsListProps1) => {
  const { data, page } = props
  return (
    <Wrap className='news-list'>
      <div
        className='banner-box'
        style={{
          backgroundImage: `url(${bannerUrl})`
        }}
      >
        <h2>新闻资讯</h2>
        <p>及时掌握最新科技动态，探索行业前沿趋势，助力企业创新发展</p>
        <div className='btn-group'>
          <a className='btn-a' href='/' title='探索解决方案'>
            联系我们
          </a>
        </div>
      </div>

      <div className='wrap'>
        <div className='float-bar'>
          <div className='group'>
            <h3>新闻分类</h3>
            <ul>
              <li className='active'>
                <a href='/'>全部新闻</a>
              </li>
              <li>
                <a href='/'>公司动态</a>
              </li>
              <li>
                <a href='/'>行业资讯</a>
              </li>
            </ul>
          </div>
          <div className='group'>
            <h3>新闻分类</h3>
            <ul>
              <li>
                <a href='/'>全部新闻</a>
              </li>
              <li>
                <a href='/'>公司动态</a>
              </li>
              <li>
                <a href='/'>行业资讯</a>
              </li>
            </ul>
          </div>
        </div>
        <div className='list-box'>
          <ul>
            {data.map(({ title, thumbnail, description, url, publishTime, type, _id }) => {
              const targetUrl = url !== '' ? url : `/news/${_id}`
              const targetThumbnail = `${STATIC_OBS_URL}/website/2025/07/${thumbnail}`.replace(
                'test-',
                ''
              )
              const tagName = type === 1 ? '公司新闻' : '行业新闻'
              const time = publishTime.split('T')[0]
              // const targetThumbnail = `https://download.globalcrown.com.cn/website/2025/07/${thumbnail}`
              return (
                <li className='item' key={_id}>
                  <div className='img'>
                    <div
                      className='pic'
                      style={{
                        backgroundImage: `url(${targetThumbnail})`
                      }}
                    />
                  </div>
                  <div className='info'>
                    <div className='topic'>
                      <span className='time'>{time}</span>
                      <a className='tag' href='/' title={tagName}>
                        {tagName}
                      </a>
                    </div>
                    <h3 className='title'>
                      <a href={targetUrl}>{title}</a>
                    </h3>
                    <p className='des'>{description}</p>
                    <a className='more' href={targetUrl} title={title}>
                      阅读全文
                    </a>
                  </div>
                </li>
              )
            })}
          </ul>
          <div className='pagination-box'>
            {pagination(page).map(item => {
              if (item.type === 'cur') {
                return (
                  <span className='item active' key={item.value}>
                    {item.value}
                  </span>
                )
              }
              return (
                <a className='item' href={`?page=${item.value}`} key={item.value}>
                  {item.value}
                </a>
              )
            })}
          </div>
        </div>
      </div>
    </Wrap>
  )
}
